module.exports = "<h3>{{text}}</h3>\n<hr/>\n\n<app-loading *ngIf=\"loading\"></app-loading>\n\n<ng-content></ng-content>"